import { render, staticRenderFns } from "./RichMenuEditor.vue?vue&type=template&id=0d8f8da3&scoped=true&"
import script from "./RichMenuEditor.vue?vue&type=script&lang=js&"
export * from "./RichMenuEditor.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuEditor.vue?vue&type=style&index=0&id=0d8f8da3&scoped=true&lang=scss&"
import style1 from "./RichMenuEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f8da3",
  null
  
)

export default component.exports